import { motion } from "framer-motion";

// Editorial hairline + wide-tracked label used across sections for a luxury feel.
export const SectionLabel = ({ children, className = "" }) => (
  <motion.div
    className={`flex items-center gap-4 ${className}`}
    initial={{ opacity: 0, x: -12 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true, amount: 0.6 }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
  >
    <span className="h-px w-8 md:w-12 bg-gradient-to-r from-[#ff4500] to-[#ff8c00]" />
    <span className="font-body text-[11px] md:text-xs uppercase tracking-[0.34em] text-[#ff8c00]">
      {children}
    </span>
  </motion.div>
);
